import React from "react";
import LoginLeft from "./LoginLeft";
import LoginRight from "./LoginRight";

const LoginPage = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Left side (hidden on mobile) */}
      <LoginLeft />

      <LoginRight />
    </div>
  );
};

export default LoginPage;
